import type { AccountAppSettingRow } from '@/lib/types/feature/account-app-setting';

/** CSVの列名（`downloadCSV` は先頭行のキーをヘッダにするため、全行で同じ順序にする） */
export interface AccountAppSettingCsvRow {
  カテゴリ: string;
  設定項目: string;
  値: string;
  状態: string;
  説明: string;
  参照元: string;
}

const STATE_LABELS = {
  set: '設定あり',
  no_row: 'レコードなし',
  null: '未設定',
} as const;

/**
 * 画面に出ている行をそのままCSVの行にする。
 *
 * 画面とCSVで内容が割れないよう、並べ替えも絞り込みもここではしない。
 * アカウントと取得日時は全行で同じ値になるので列には持たず、ファイル名で表す。
 */
export function toCsvRows(rows: AccountAppSettingRow[]): AccountAppSettingCsvRow[] {
  return rows.map((row) => ({
    カテゴリ: row.category,
    設定項目: row.label,
    値: row.value,
    状態: STATE_LABELS[row.value_state] ?? row.value_state,
    説明: row.description,
    参照元: row.source,
  }));
}
